<div class="padding-20">
    <h2 class="mat-title">
        Email Testing
    </h2>
    <p>Test individual email templates</p>
    <form fxLayout="column" fxLayoutGap="15px">
        <div style="width: 350px;">
            <form-label>Email Templates: </form-label>
            <mat-form-field class="templateList">
                <mat-select #tempFC [(value)]="selectedEmailTemplate" required>
                    <mat-option>None</mat-option>
                    <mat-option *ngFor="let template of ListOfEmailTemplates" [value]="template.value">{{ template.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    
        <div style="width: 350px;">
            <form-label>Email: </form-label>
            <mat-form-field class="email">
                <input matInput #emailFC type="text" [(ngModel)]="email" name="email" placeholder="Email" required email />
            </mat-form-field>
        </div>
    
        <div style="width: 350px;">
            <form-label>Message: </form-label>
            <mat-form-field class="message">
                <textarea matInput #messageFC type="textarea" [(ngModel)]="message" name="message" placeholder="Type in the message to test"></textarea>
            </mat-form-field>
        </div>
    </form>
    
    <button type="button" mat-raised-button color="primary" (click)="TestEmail(selectedEmailTemplate, emailFC.value, messageFC.value)">Test Email</button>
</div>


// WEBPACK FOOTER //
// ./src/app/admin-settings/components/email-test/email-test.component.html